module.exports = __webpack_public_path__ + "static/media/che_filled.497ec372.svg";